module.exports = __webpack_public_path__ + "static/media/triangle.e34a1e42.svg";